import React, { useState } from "react";
// import './FAQforhomepage.css';
import "./TestCr.css";
import "./FAQredo.css";
import { VscChromeClose, VscAdd } from "react-icons/vsc";
// import { ImPlus, ImCross } from "react-icons/im";

const FAQstructure = ({ value, key }) => {
  const [show, setshow] = useState(true);
  const [isopen, setisopen] = useState("bgcolorNew bgcolorNew1");
  const [forBg, setBg] = useState(false);
  const { id, title, desc } = value;

  const TogglebgColor = () => {
    setshow(!show);
    setBg(!forBg);
  };

  return (
    <React.Fragment>
      <div className="faqNew faqNew1">
        <div
          className={
            forBg
              ? "bgBlue bgBlue1 bgcolorNew bgcolorNew1"
              : "bgcolorNew bgcolorNew1"
          }
          onClick={TogglebgColor}
        >
          {/* <h3 className={`title ${isopen}`}>{title}
            </h3> */}
          <h3 className={forBg ? " " : "colorBlue colorBlue1"}>{title}</h3>
          <div className={forBg ? "FontWhite" : "forIcons"}>
            <span>
              {!show && <VscChromeClose cursor="pointer" strokeWidth="0.5px" />}
            </span>
            <span>{show && <VscAdd cursor="pointer" strokeWidth="1px" />}</span>
          </div>
        </div>
        <p hidden={show}>{desc}</p>
      </div>
    </React.Fragment>
  );
};

export default FAQstructure;
